import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { ExternalLink, Download } from "lucide-react";

export const isPdfFile = (name, ct) =>
  (ct || "").toLowerCase().includes("pdf") || /\.pdf(\?|$)/i.test(name || "");

// عارض ملفات داخل الصفحة (صورة أو PDF) بدون فتح صفحة جديدة
export const FileLightbox = ({ open, onOpenChange, url, name, isPdf }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl max-h-[92vh] overflow-hidden flex flex-col p-3" dir="rtl" data-testid="file-lightbox">
      <DialogHeader className="pb-1">
        <DialogTitle className="text-base font-heading truncate pl-8">{name || "عرض الملف"}</DialogTitle>
      </DialogHeader>
      <div className="flex-1 overflow-auto rounded-lg bg-slate-50 flex items-center justify-center min-h-[300px]">
        {url && (isPdf ? (
          <iframe src={url} title={name || "ملف"} className="w-full h-[78vh] rounded-lg" data-testid="lightbox-pdf" />
        ) : (
          <img src={url} alt={name || "ملف"} className="max-w-full max-h-[80vh] object-contain" data-testid="lightbox-img" />
        ))}
      </div>
      {url && (
        <div className="flex items-center justify-end gap-3 pt-2 text-sm">
          <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-slate-500 hover:text-slate-800">
            <ExternalLink className="h-4 w-4" /> فتح في نافذة جديدة
          </a>
          <a href={`${url}${url.includes("?") ? "&" : "?"}download=1`} className="inline-flex items-center gap-1 text-indigo-600 hover:text-indigo-800">
            <Download className="h-4 w-4" /> تحميل
          </a>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
